<script lang="ts">
	import { appStore } from '../stores/appStore';
	import type { AppApiClient } from '../api_contracts/app.client';

	let client: AppApiClient | null = $state(null);
	let token: string = $state('');
	let loading: boolean = $state(false);
	let response: any = $state(null);
	let error: string = $state('');

	// Subscribe to store
	appStore.subscribe(state => {
		client = state.client;
		token = state.token;
	});

	// Test SayHello RPC
	async function testSayHello() {
		if (!client) {
			error = 'gRPC client not initialized';
			return;
		}

		try {
			loading = true;
			error = '';
			response = null;

			const result = await client.sayHello({});

			response = result.response;
			console.log('SayHello response:', result.response);
		} catch (e: any) {
			error = e.message || 'Error calling SayHello';
			console.error('Error:', e);
		} finally {
			loading = false;
		}
	}

	// Test Login RPC
	async function testLogin() {
		if (!client) {
			error = 'gRPC client not initialized';
			return;
		}

		try {
			loading = true;
			error = '';
			response = null;

			const loginRequest = {
				browserName: 'Chrome',
				osName: 'Windows',
				email: 'test@example.com',
				password: 'password123'
			};

			const result = await client.login(loginRequest);

			response = result.response;
			console.log('Login response:', result.response);
		} catch (e: any) {
			error = e.message || 'Error calling Login';
			console.error('Error:', e);
		} finally {
			loading = false;
		}
	}

	// Test ValidateToken RPC
	async function testValidateToken() {
		if (!client) {
			error = 'gRPC client not initialized';
			return;
		}

		if (!token) {
			error = 'No token available';
			return;
		}

		try {
			loading = true;
			error = '';
			response = null;

			const result = await client.validateToken({ token });

			response = result.response;
			console.log('ValidateToken response:', result.response);
		} catch (e: any) {
			error = e.message || 'Error calling ValidateToken';
			console.error('Error:', e);
		} finally {
			loading = false;
		}
	}
</script>

<main>
	<h1>gRPC Tests</h1>

	<div class="status">
		<p><strong>Client Status:</strong> {client ? '✓ Connected' : '✗ Not Connected'}</p>
		<p><strong>Token:</strong> {token || 'No token'}</p>
	</div>

	<div class="tests">
		<h2>Test RPC Methods</h2>

		<div class="test-group">
			<button onclick={testSayHello} disabled={loading || !client}>
				{loading ? 'Loading...' : 'Test SayHello'}
			</button>

			<button onclick={testLogin} disabled={loading || !client}>
				{loading ? 'Loading...' : 'Test Login'}
			</button>

			<button onclick={testValidateToken} disabled={loading || !client || !token}>
				{loading ? 'Loading...' : 'Test ValidateToken'}
			</button>
		</div>

		{#if error}
			<div class="error">
				<h3>Error:</h3>
				<pre>{error}</pre>
			</div>
		{/if}

		{#if response}
			<div class="response">
				<h3>Response:</h3>
				<pre>{JSON.stringify(response, null, 2)}</pre>
			</div>
		{/if}
	</div>

	<nav>
		<a href="#/">← Back to Home</a>
	</nav>
</main>

<style>
	main {
		padding: 2em;
		max-width: 800px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-align: center;
	}

	h2 {
		color: #333;
		margin-top: 2em;
	}

	.status {
		background: #f0f0f0;
		padding: 1em;
		border-radius: 4px;
		margin: 1em 0;
	}

	.status p {
		margin: 0.5em 0;
	}

	.tests {
		margin-top: 2em;
	}

	.test-group {
		display: flex;
		gap: 1em;
		flex-wrap: wrap;
		margin: 1em 0;
	}

	button {
		background-color: #ff3e00;
		color: white;
		border: none;
		padding: 0.8em 1.5em;
		font-size: 1em;
		border-radius: 4px;
		cursor: pointer;
		transition: background-color 0.2s;
	}

	button:hover:not(:disabled) {
		background-color: #ff5722;
	}

	button:disabled {
		background-color: #ccc;
		cursor: not-allowed;
	}

	.error {
		background: #ffebee;
		border: 1px solid #ef5350;
		padding: 1em;
		border-radius: 4px;
		margin-top: 1em;
	}

	.error h3 {
		color: #c62828;
		margin-top: 0;
	}

	.response {
		background: #e8f5e9;
		border: 1px solid #66bb6a;
		padding: 1em;
		border-radius: 4px;
		margin-top: 1em;
	}

	.response h3 {
		color: #2e7d32;
		margin-top: 0;
	}

	pre {
		background: white;
		padding: 1em;
		border-radius: 4px;
		overflow-x: auto;
		font-size: 0.9em;
	}

	nav {
		margin-top: 2em;
		text-align: center;
	}

	a {
		color: #ff3e00;
		text-decoration: none;
		font-weight: bold;
	}

	a:hover {
		text-decoration: underline;
	}
</style>
